/**
 * Преобразует ISO-строку даты из UTC в локальное время с учётом смещения.
 * Например: "2025-07-17T21:00:00Z" с "+03:00" -> "2025-07-18T00:00:00.000Z"
 * @param {string} isoString - ISO-строка даты в UTC.
 * @param {string} utcOffset - Смещение UTC (например "+03:00").
 * @returns {string} ISO-строка с применённым смещением.
 */
function convertUTCToLocalISOString(isoString, utcOffset) {
  if (!isoString || !utcOffset) return '';

  const date = new Date(isoString);
  if (Number.isNaN(date)) return '';

  const sign = utcOffset.startsWith('-') ? -1 : 1;
  const [hoursStr, minutesStr = '0'] = utcOffset.replace(/[+-]/, '').split(':');
  const hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);

  if (Number.isNaN(hours) || Number.isNaN(minutes)) return '';

  date.setUTCHours(date.getUTCHours() + sign * hours);
  date.setUTCMinutes(date.getUTCMinutes() + sign * minutes);

  return date.toISOString();
}

export default convertUTCToLocalISOString;
